<template>
  <div>
    <van-popup
      v-model="isShowVideo"
      position="bottom"
      :style="{ height: '100%', background: '#f5f5f5' }"
    >
    <van-nav-bar fixed>
        <div slot="title">发布视频</div>
        <div slot="right" @click="close">关闭</div>
      </van-nav-bar>
    <div class="video-main clearfix">
      <div class="video-box">
        <div class="video-div add-video">
          <video controls>
            <source :src="videoUrls" />
          </video>
        </div>
      </div>
      <div class="foot-btn">
        <van-button
          class="creatBtn fl"
          style="width:30%;"
          size="large"
          type="default"
          @click.native="videoRelease"
        >重选</van-button>
        <van-button
          class="creatBtn fr"
          style="width:70%; border-radius: 0;"
          size="large"
          type="info"
          @click.native="creatUser"
        >发布到班牌</van-button>
      </div>
    </div>
    </van-popup>
  </div>
</template>
<script>
export default {
  name: "SendVideo",
  props: {
    isShowVideo: Boolean,
    videoUrl:String
  },
  data() {
    return {
      imgData: [],
      type: 8
    };
  },
  computed: {
    videoUrls(){
      return `${this.xyViewUrl}${this.videoUrl}`
    }
  },
  methods: {
    close() {
      this.$emit("listenToChildClose", false);
    },
    // 路径转换
    transformFileToDataUrl(file) {
      for (var i = 0; i < file.length; i++) {
        // 封装好的函数
        var reader = new FileReader();
        reader.readAsDataURL(file[i]);
        // console.log(file[i])
        var imgList = [];

        // file转dataUrl是个异步函数，要将代码写在回调里
        reader.onload = function(e) {
          var result = e.target.result;
          imgList.push(result);
        };
      }
      console.log(reader)
      this.imgData = imgList;
      console.log(this.imgData);
    },

    // 重选
    videoRelease() {
      this.$router.push("/home/ClassCardInfoSend");
    },

    // 发送到班牌
    creatUser() {
      var classTerminal = [];
      this.$store.commit("infoPublic/setPicfilesUrls", this.videoUrl);
      this.$store.commit("infoPublic/settypePic", this.type);
      this.$store.commit("infoPublic/setclassTerminal", classTerminal);
      this.$router.push("/home/SelectClassCard");
    }
  }
};
</script>
<style lang="less" scoped>
.video-main {
  background: #fff;
  margin-top:100px;
}
.video-main > .video-box {
  width: 70%;
  margin: 0 auto;
  margin-top: 25px;
}
.video-main > .video-box > .video-div {
  width: 100%;
  overflow: hidden;
  display: inline-block;
  margin: 2.5px;
  background: #ededed;
  vertical-align: top;
}
.video-main > .video-box > .video-div > video {
  width: 100%;
}
.video-main > .video-box > .video-div > .video-img {
  width: 100%;
}
.video-main > .video-box > .add-video {
  display: inline-block;
  margin-left: -0.83px;
  cursor: pointer;
}

.video-main > .video-box > .add-video > .add-video-img {
  display: block;
  margin: 35px auto;
}

.foot-btn {
  width: 100%;
  display: block;
  position: fixed;
  bottom: 0;
}
// .creatBtn {
// }
</style>
